/**
 * @see https://umijs.org/docs/max/access#access
 */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const userGroup = Number(currentUser?.user_group || 0);

  return {
    canAdmin: userGroup === 1,
    canOrderManage: userGroup === 1 || userGroup === 2,
  };
}
